import React from 'react';
import classNames from 'classnames';
import WingBlank from '../WingBlank';
import './Layer.less';

// size取值为'large', 'middle'和'small'
function Layer({title, size='large', grey=false, className, children, ...props}) {
  return (
    <WingBlank className={classNames('Layer', className)} {...props} data-mode={grey ? 'grey' : null} data-size={size}>
      <h1>{title}</h1>
      {children}
    </WingBlank>
  );
}

export default Layer;


// WEBPACK FOOTER //
// ./src/components/Layer/Layer.js